module.exports = __webpack_public_path__ + "3ad568ac8fb063f87b8b78d9d2af6cd8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tsp-icon-circle-1.png
// module id = 1927
// module chunks = 0